import { Grid } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { AttributeBadge } from '@tassat/symbols';
import React from 'react';

interface IsPrimaryCellRendererProps {
    data: any;
}

const muiStyles = makeStyles({
    root: {
        height: '100%',
        minWidth: '80px',
        whiteSpace: 'normal' as const,
        '& #accsymbol': {
            '& div': {
                color: '#B28C69',
                border: '1px solid #B28C69'
            }
        },

        '& #noAcc': {
            height: '28px',
            width: '28px'
        }
    },
    primarySymbol: {
        color: '#202020',
        background: '#EDCB26',
        border: '1px solid #CFCFCF'
    }
});

const IsPrimaryCellRenderer = (props: IsPrimaryCellRendererProps) => {
    const { data } = props;

    const classes = muiStyles(props);
    const isPrimaryCheck = data?.wallet ? data?.wallet.IsPrimary : data?.IsPrimary;

    return (
        <Grid
            alignItems='center'
            className={classes.root}
            container
            direction='row'
            justifyContent='space-between'
            spacing={0}
        >
            {isPrimaryCheck && <AttributeBadge
                active
                className={classes.primarySymbol}
                testId='account-is-primary'
                value={isPrimaryCheck && 'P'}
            />}
        </Grid>
    );
};

export default IsPrimaryCellRenderer;